import React from "react";
import { Typography, Row, Col } from "antd";
import { FormattedMessage } from "react-intl";

import "./index.css";
import config from "../../../config";
import ExternalLink from "../../app/generic/externalLink";

const { Text } = Typography;

const LoginFormContainer = ({ children }) => (
  <Row
    type="flex"
    align="middle"
    justify="center"
    className="login-form-container center"
  >
    <Col xxl={6} sm={10}>
      <Row>
        {children}
        <Col className="registration-container">
          <ExternalLink
            id="user.register"
            href={config.REGISTER_URL}
            defaultMessage="Nová registrace"
            className="registration-text"
            titleId="user.register.title"
            titleDefaultMessage="Dojde k přesměrování na web e-registrace"
          />
        </Col>
        <Col>
          <Text type="secondary" className="small-font">
            <FormattedMessage
              id="user.signIn.message"
              defaultMessage="Webová aplikace pro zákazníky firmy DHL, určená k zadávání a správě objednávek."
            />
            <br />
            <FormattedMessage
              id="user.signIn.contact"
              defaultMessage="V případě problémů kontaktujte náš zákaznický servis na tel. čísle +420 239 018 222."
            />
          </Text>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default LoginFormContainer;
